import {
  SET_PROCESSING_STATE,
  SET_GENERATE,
  SET_IS_LOADING,
  SET_SUBMITTING_DOC,
  SET_HAS_PREVIEW,
  SET_IS_GENERATING,
  SET_LOADING_MESSAGE,
  SET_EXTRACTION_METADATA,
  GENERATE_SUBJECT_DOCUMENT,
  GENERATE_SUBJECT_DOCUMENT_SUCCESS,
  GENERATE_SUBJECT_DOCUMENT_FAILURE,
  SET_DOC_PROCESSING_STATUS,
  CLEAR_DOC_PROCESSING_STATUS
} from '../../actions/types';

// Handler per l'azione SET_PROCESSING_STATE
export const handleSetProcessingState = (state, payload) => {
  return {
    ...state,
    isProcessing: payload,
  };
};

// Handler per l'azione SET_GENERATE
export const handleSetGenerate = (state, payload) => {
  return {
    ...state,
    isGenerate: payload,
  };
};

// Handler per l'azione SET_IS_LOADING
export const handleSetIsLoading = (state, payload) => {
  return {
    ...state,
    isLoading: payload,
  };
};

// Handler per l'azione SET_SUBMITTING_DOC
export const handleSetSubmittingDoc = (state, payload) => {
  return {
    ...state,
    isSubmitting: payload,
  };
};

// Handler per l'azione SET_HAS_PREVIEW
export const handleSetHasPreview = (state, payload) => {
  return {
    ...state,
    hasPreview: payload
  };
};

// Handler per l'azione SET_IS_GENERATING
export const handleSetIsGenerating = (state, payload) => {
  return {
    ...state,
    isGenerating: payload
  };
};

// Handler per l'azione GENERATE_SUBJECT_DOCUMENT
export const handleGenerateSubjectDocument = (state) => {
  return {
    ...state,
    isGenerating: true,
    generationError: null
  };
};

// Handler per l'azione GENERATE_SUBJECT_DOCUMENT_SUCCESS
export const handleGenerateSubjectDocumentSuccess = (state, payload) => {
  return {
    ...state,
    isGenerating: false,
    generatedDocument: payload,
    // Aggiorna documentsQA per mostrare il contenuto generato
    documentsQA: [
      {
        id: payload.id,
        title: payload.title,
        tags: payload.tags,
        examExtractedQA: payload.examExtractedQA || [],
        rawExamData: payload.rawExamData || {},
        rawFlashcards: payload.rawFlashcards || {},
        quiz_questions: payload.quiz_questions || [],
        summary: payload.summary || {}
      }
    ]
  };
};

// Handler per l'azione GENERATE_SUBJECT_DOCUMENT_FAILURE
export const handleGenerateSubjectDocumentFailure = (state, payload) => {
  return {
    ...state,
    isGenerating: false,
    generationError: payload
  };
};

// Handler per l'azione SET_LOADING_MESSAGE
export const handleSetLoadingMessage = (state, payload) => {
  console.log('Reducer: SET_LOADING_MESSAGE', payload);
  
  // Gestisce diversi formati di payload (oggetto, stringa, null)
  if (payload === null) {
    return {
      ...state,
      loadingMessage: null,
      loadingProgress: null
    };
  } else if (typeof payload === 'object') {
    return {
      ...state,
      loadingMessage: payload.message,
      loadingProgress: payload.progress
    };
  } else {
    // Se è una stringa o altro valore primitivo
    return {
      ...state,
      loadingMessage: payload,
      loadingProgress: null
    };
  }
};

// Handler per l'azione SET_EXTRACTION_METADATA
export const handleSetExtractionMetadata = (state, payload) => {
  console.log('Reducer: SET_EXTRACTION_METADATA', payload);
  return {
    ...state,
    extractionMetadata: payload
  };
};

// Handler per SET_DOC_PROCESSING_STATUS
// payload: { status: string, error: string|null, docId: string }
export const handleSetDocProcessingStatus = (state, payload) => {
  return {
    ...state,
    docProcessingStatus: payload.status || null,
    docProcessingError: payload.error || null,
    docProcessingDocId: payload.docId || null,
  };
};

// Handler per CLEAR_DOC_PROCESSING_STATUS — resetta tutto dopo done/error/cleanup
export const handleClearDocProcessingStatus = (state) => {
  return {
    ...state,
    docProcessingStatus: null,
    docProcessingError: null,
    docProcessingDocId: null,
  };
};

// Reducer per gestire le azioni relative allo stato di caricamento
const loadingStateReducer = (state, action) => {
  switch (action.type) {
    case SET_PROCESSING_STATE:
      return handleSetProcessingState(state, action.payload);
    case SET_GENERATE:
      return handleSetGenerate(state, action.payload);
    case SET_IS_LOADING:
      return handleSetIsLoading(state, action.payload);
    case SET_SUBMITTING_DOC:
      return handleSetSubmittingDoc(state, action.payload);
    case SET_HAS_PREVIEW:
      return handleSetHasPreview(state, action.payload);
    case SET_IS_GENERATING:
      return handleSetIsGenerating(state, action.payload);
    case GENERATE_SUBJECT_DOCUMENT:
      return handleGenerateSubjectDocument(state);
    case GENERATE_SUBJECT_DOCUMENT_SUCCESS:
      return handleGenerateSubjectDocumentSuccess(state, action.payload);
    case GENERATE_SUBJECT_DOCUMENT_FAILURE:
      return handleGenerateSubjectDocumentFailure(state, action.payload);
    case SET_LOADING_MESSAGE:
      return handleSetLoadingMessage(state, action.payload);
    case SET_EXTRACTION_METADATA:
      return handleSetExtractionMetadata(state, action.payload);
    case SET_DOC_PROCESSING_STATUS:
      return handleSetDocProcessingStatus(state, action.payload);
    case CLEAR_DOC_PROCESSING_STATUS:
      return handleClearDocProcessingStatus(state);
    default:
      return null; // Indica che questa azione non è gestita da questo reducer
  }
};

export default loadingStateReducer; 